<div draggable="true" ngClass="{{ dragAreaClass }}" class="upload_box">
  <div class="row">
    <div class="col-md-12 text-center">
      <i class="material-icons"> cloud_upload </i>
      <p *ngIf="this.lastImportedDate" class="info-text-warning">
        <i class="material-icons err-icon">info</i>
        <span>
          Last Import date/time:
          {{ this.lastImportedDate | date: 'dd/MM/yyyy' }}
          {{ this.lastImportedDate | date: 'shortTime' }}
          UTC
        </span>
      </p>
      <p class="info-text">
        Drag and drop or <a (click)="file.click()">browse</a>
        {{ maxFiles > 1 ? '(Up to ' + maxFiles + ' files.)' : '(1 document allowed.)' }}
      </p>
      <input type="file" #file [multiple]="maxFiles > 1" (change)="onFileChange($event)" style="display: none" />
    </div>
  </div>
</div>

<div class="row" *ngIf="errors.length > 0">
  <div class="col-md-12">
    <ul class="list-group list-group-flush file-upload-list">
      <li *ngFor="let err of errors" class="error mt-3">
        <div class="col-4" *ngIf="err.name.length > 0" title="{{ err.name }}">
          <i class="material-icons"> insert_drive_file </i>
          {{ err.name }}
        </div>
        <div class="col-4" *ngIf="err.status.length > 0" title="{{ err.status }}">
          {{ err.status }}
        </div>
        <div class="col-4">
          <a class="upload-file-action-button" (click)="deleteScreenshot(err.name)"><i class="material-icons">delete_forever</i></a>
        </div>
      </li>
    </ul>
  </div>
</div>

<div class="row" *ngIf="success.length > 0">
  <div class="col-md-12">
    <ul class="list-group list-group-flush file-upload-list">
      <li *ngFor="let val of success" class="mt-3">
        <div class="col-4" *ngIf="val.name.length > 0" title="{{ val.name }}"><i class="material-icons"> insert_drive_file </i> {{ val.name }}</div>

        <div class="col-4" *ngIf="val.status.length > 0" title=" {{ val.status }}">
          {{ val.status }}
        </div>
        <div class="col-4">
          <a class="upload-file-action-button" (click)="deleteScreenshot(val.name)"><i class="material-icons">delete_forever</i></a>
        </div>
      </li>
    </ul>
  </div>
</div>
